import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';

export type CountyFolder = {
  counties: Array<County>;
};

export type County = {
  id: string;
  countyName: string;
  image: ImageField;
  state: string;
  area: string; //Depricated?
};
